import { Component, Input } from "@angular/core";
import { Message } from "../../../@core/state/chat.store";
import { MarkdownComponent } from "../../../@shared/markdown/markdown.component";
import { ChatAnswerErrorComponent } from "./chat-answer-error/chat-answer-error.component";
import { ChatAnswerLoadingComponent } from "./chat-answer-loading/chat-answer-loading.component";

@Component({
  selector: "app-chat-answer",
  imports: [
    MarkdownComponent,
    ChatAnswerErrorComponent,
    ChatAnswerLoadingComponent,
  ],
  templateUrl: "./chat-answer.component.html",
  styleUrl: "./chat-answer.component.scss",
})
export class ChatAnswerComponent {
  @Input({ required: true }) message!: Message;
}
